export default "__VITE_ASSET__DwWwt7UD__"